import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { IPlayer } from "../types/ILobbyView";
import { GameModeEnum } from "../types/gameModeEnum";
import { IPlayerView } from "../types/IPlayerView";
import { IDeadView } from "../types/IDeadView";
import { RoleClassEnum } from "../types/roleClassEnum";
import ScenarioUtils from "../utils/scenarioUtils";

export interface GameState {
    lobbyPlayers: IPlayer[];
    playerView?: IPlayerView;
    playerRole: RoleClassEnum;
    readMessages: boolean,
    deadView?: IDeadView;
    hostName: string;
    gameMode: GameModeEnum;
    time: number,
    day: number,
    targets: number[],
}

const initialState: GameState = {
    lobbyPlayers: [],
    playerView: undefined,
    playerRole: RoleClassEnum.Neutral,
    deadView: undefined,
    readMessages: true,
    hostName: '',
    gameMode: GameModeEnum.Login,
    time: 0,
    day: 0,
    targets: [],
}

export const gameSlice = createSlice({
    name: 'game',
    initialState,
    reducers: {
        setLobbyPlayers: (state, action: PayloadAction<IPlayer[]>) => {
            return {
                ...state,
                lobbyPlayers: action.payload,
            }
        },
        setHostName: (state, action: PayloadAction<string>) => {
            return {
                ...state,
                hostname: action.payload,
            }
        },
        setGameMode: (state, action: PayloadAction<GameModeEnum>) => {
            return {
                ...state,
                gameMode: action.payload,
            }
        },
        setTimeAndDay: (state, action: PayloadAction<{ time: number, day: number }>) => {
            return {
                ...state,
                time: action.payload.time,
                day: action.payload.day,
            }
        },
        setPlayerView: (state, action: PayloadAction<IPlayerView>) => {
            return {
                ...state,
                playerView: action.payload,
                playerRole: ScenarioUtils.CheckRole(action.payload.role_name),
                readMessages: action.payload.messages.length === 0,
            }
        },
        setReadMessages: (state) => {
            return {
                ...state,
                readMessages: true,            
            }
        },
        setDeadView: (state, action: PayloadAction<IDeadView>) => {
            return {
                ...state,
                deadView: action.payload,
            }
        },
        setTargets: (state, action: PayloadAction<number[]>) => {
            return {
                ...state,
                targets: action.payload,
            }
        }
    }
});

export const {
    setLobbyPlayers,
    setHostName,
    setGameMode,
    setTimeAndDay,
    setPlayerView,
    setDeadView,
    setTargets,
    setReadMessages } = gameSlice.actions;
export default gameSlice.reducer;